import { Component } from 'react'

class Analytics extends Component {
    componentDidMount() {
        const script = document.createElement('script')
        script.async = true
        script.src =
            'https://www.googletagmanager.com/gtag/js?id=UA-137947963-1'

        document.body.appendChild(script)

        window.dataLayer = window.dataLayer || []
        function gtag() {
            window.dataLayer.push(arguments)
        }
        gtag('js', new Date())
        gtag('config', 'UA-137947963-1')
    }

    render() {
        return false
    }
}

export default Analytics
